import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import "../ForgotPass/ForgotPass.css";

const InvalidToken = () => {
  return (
    <div className="forgot-page">
      <div className="forgot-card">

        <NavLink to="/">
          <img src={logo} alt="Casa del Padel" className="forgot-logo" />
        </NavLink>

        <h1 className="forgot-title">Lien expiré</h1>
        <p className="forgot-subtitle">
          Ce lien de réinitialisation est invalide ou a expiré. Veuillez recommencer le processus.
        </p>

        <NavLink to="/forgot-pass" className="forgot-submit" style={{ display: "block", textAlign: "center", textDecoration: "none" }}>
          Demander un nouveau lien
        </NavLink>

        <p className="forgot-back-hint">
          <NavLink to="/login" className="forgot-back-link">
            ← Retour à la connexion
          </NavLink>
        </p>

      </div>
    </div>
  );
};

export default InvalidToken;
